// ============================================================================
// AI INSIGHTS MODAL STYLES
// CSS styles for export modal and other UI modals
// ============================================================================

/**
 * Returns CSS styles for modals used in the AI Insights component
 * These are separate from the dashboard styles and are used in the React component
 */
export const getModalStyles = () => `
  <style>
    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(9, 30, 66, 0.54);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
    }

    .modal-content {
      background: #ffffff;
      border-radius: 8px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
      max-width: 600px;
      width: 90%;
      max-height: 90vh;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .modal-header {
      padding: 24px 24px 16px;
      border-bottom: 1px solid #dfe1e6;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .modal-header h2 {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #172b4d;
    }

    .modal-close-button {
      background: none;
      border: none;
      cursor: pointer;
      padding: 8px;
      border-radius: 3px;
      color: #42526e;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s;
    }

    .modal-close-button:hover {
      background: #f4f5f7;
    }

    .modal-body {
      padding: 24px;
      overflow-y: auto;
      flex: 1;
    }

    .export-option {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 20px;
      border: 2px solid #dfe1e6;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s;
      margin-bottom: 16px;
    }

    .export-option:last-child {
      margin-bottom: 0;
    }

    .export-option:hover {
      border-color: #0052cc;
      background: #f4f5f7;
    }

    .export-content {
      flex: 1;
    }

    .export-option-title {
      font-size: 16px;
      font-weight: 600;
      color: #172b4d;
      margin-bottom: 4px;
    }

    .export-option-description {
      font-size: 13px;
      color: #5e6c84;
      line-height: 1.4;
    }

    .modal-footer {
      padding: 16px 24px;
      border-top: 1px solid #dfe1e6;
      display: flex;
      justify-content: flex-end;
      gap: 8px;
    }

    .modal-cancel-button {
      background: #fff;
      border: 1px solid #dfe1e6;
      border-radius: 3px;
      padding: 8px 16px;
      font-size: 14px;
      font-weight: 500;
      color: #42526e;
      cursor: pointer;
      transition: background 0.2s;
    }

    .modal-cancel-button:hover {
      background: #f4f5f7;
    }
  </style>
`;

/**
 * Inject modal styles into the document
 * Call this once when the component mounts
 */
export const injectModalStyles = () => {
  // Check if styles already injected
  if (document.getElementById('ai-insights-modal-styles')) {
    return;
  }

  const styleElement = document.createElement('style');
  styleElement.id = 'ai-insights-modal-styles';
  styleElement.innerHTML = getModalStyles().replace(/<\/?style>/g, '');
  document.head.appendChild(styleElement);
};

/**
 * Remove modal styles from the document
 * Call this when the component unmounts if needed
 */
export const removeModalStyles = () => {
  const styleElement = document.getElementById('ai-insights-modal-styles');
  if (styleElement) {
    styleElement.remove();
  }
};
